import { CustomActionDto } from '@ampsec/platform-client';
import { getPlatformIntuneRebootUrl } from './platformIntuneRebootUrl';

export interface BuildMicrosoftIntuneRebootRestActionInput {
    displayValue: string;
    description?: string;
    retryStrategy?: CustomActionDto['retryStrategy'];
}

export const buildMicrosoftIntuneRebootRestAction = ({
    displayValue,
    description,
    retryStrategy,
}: BuildMicrosoftIntuneRebootRestActionInput): CustomActionDto => ({
    id: '',
    displayValue,
    description,
    kind: 'REST_ACTION',
    isTemplate: false,
    meta: {
        request: {
            method: 'POST',
            url: getPlatformIntuneRebootUrl(),
            params: {},
            headers: {
                'Content-Type': 'application/json',
            },
            // Empty JSON body: action-engine merges `{tid}` into it at execution time so
            // amp-platform-api's service-account-guarded endpoint knows which tenant to scope to.
            payload: {
                kind: 'TEMPLATE',
                format: 'JSON',
                value: '{}',
            },
        },
    },
    retryStrategy: retryStrategy ?? {
        kind: 'CONSTANT_BACKOFF',
        maxRetries: 0,
        delay: 0,
    },
    createdAt: new Date().toISOString(),
    updatedAt: new Date().toISOString(),
    deletedAt: null,
});
